import { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import { enqueueSnackbar } from '../snackbar';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { useSetInvoicePaidMutation } from '../../hooks';
import { i18n } from '../../i18n';
import { MESSAGES } from '../../const';

interface InvoicePaidModalType {
  invoiceId: string;
  invoiceNumber?: string;
  submitClick: () => void;
  open: () => void;
}

export const invoicePaidModal: InvoicePaidModalType = {
  invoiceId: '',
  invoiceNumber: '',
  submitClick: () => null,
  open: () => null,
};

export const InvoicePaidModal = () => {
  const { mutate, isLoading } = useSetInvoicePaidMutation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    invoicePaidModal.open = () => {
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    invoicePaidModal.invoiceId = '';
    invoicePaidModal.invoiceNumber = '';
    setOpen(false);
  };

  const handleSubmitClick = () => {
    if (!invoicePaidModal.invoiceId) return;

    mutate(invoicePaidModal.invoiceId, {
      onSuccess: () => {
        setOpen(false);
        enqueueSnackbar(MESSAGES.INVOICE.SUCCESS.PAID, 'success');
        invoicePaidModal.submitClick();
      },
    });
  };

  return (
    <ModalBase id={'invoice-paid-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.invoicePaidTitle')}: {invoicePaidModal.invoiceNumber}
        </Typography>

        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose} disabled={isLoading}>
            {i18n.t('button.cancel')}
          </Button>
          <Button
            size={'medium'}
            data-color={'primary'}
            onClick={handleSubmitClick}
            disabled={isLoading}
          >
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
